export const COMPANYLESS_LANDING_PATH = '/onboarding/company-search';

interface MeShape {
  id?: string;
  company?: { id?: string } | null;
  companyId?: string | null;
}

interface CompanyContext {
  companyId?: string | null;
}

/**
 * True only when the user is authenticated AND has no company context at
 * all for this session — not `me.company` and not a switched `companyId`.
 * Either one means the user has a company to operate in right now, even if
 * `me.company` itself hasn't caught up yet.
 */
export function isCompanyless(
  me: MeShape | null | undefined,
  { companyId }: CompanyContext,
): boolean {
  return Boolean(me?.id && !me.company?.id && !me.companyId && !companyId);
}
